import React, { useMemo, useCallback } from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';
import TagPickerPopover from './TagPickerPopover';

import { cardSurface } from './Card';
const TagIcon = (props) => (
  <Box as="svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
    <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
  </Box>
);

/**
 * Inline tag picker - shows colored dots + count, click to toggle tags
 */
const InlineTagPicker = ({ movement, allTags, onTagsChange, alwaysShowEmpty = false }) => {
  const currentTagIds = useMemo(() =>
    new Set((movement.tag_movements || []).map(tm => tm.tag.id)),
    [movement.tag_movements]
  );

  const currentTags = useMemo(() =>
    (movement.tag_movements || []).map(tm => tm.tag),
    [movement.tag_movements]
  );

  const handleToggle = useCallback((tag) => {
    const newTagIds = currentTagIds.has(tag.id)
      ? [...currentTagIds].filter(id => id !== tag.id)
      : [...currentTagIds, tag.id];
    onTagsChange(movement.id, newTagIds, allTags);
  }, [movement.id, currentTagIds, onTagsChange, allTags]);

  return (
    <TagPickerPopover allTags={allTags} selectedTagIds={currentTagIds} onToggle={handleToggle}>
      {currentTags.length > 0 ? (
        <Flex {...cardSurface}
          align="center"
          gap="3px"
          borderRadius="full"
          px="6px"
          py="2px"
          _hover={{ borderColor: "redesign.text.muted" }}
          flexShrink={0}
          cursor="pointer"
        >
          {currentTags.slice(0, 3).map(tag => (
            <Box key={tag.id} w="7px" h="7px" borderRadius="full" bg={tag.color || "#3182CE"} />
          ))}
          <Text fontSize="2xs" fontWeight="500" color="redesign.text" ml="2px">{currentTags.length}</Text>
        </Flex>
      ) : (
        <Box
          opacity={alwaysShowEmpty ? 1 : 0}
          _groupHover={{ opacity: 1 }}
          transition="opacity 0.15s"
          color="redesign.text.muted"
          _hover={{ color: "redesign.text" }}
          flexShrink={0}
          cursor="pointer"
        >
          <TagIcon w="14px" h="14px" />
        </Box>
      )}
    </TagPickerPopover>
  );
};

export default InlineTagPicker;
